import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import { analytics } from "@flare/analytics";
import { useTranslation } from "@flare/i18n";
import { Button, Heading, Text } from "@flare/ui/components";

import { BiEventsNames } from "@/services/analytics/bi-event-names";

import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

import type { StepProps } from "./step.types";

export default function OutOfScope({ answers }: StepProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const data = answers ? answers : {};
  const practice = router.query.practice ?? data?.practice;

  const answersUrl = `https://www.marble.co/${practice}/answers`;

  function getAnswersHandler() {
    analytics.track(BiEventsNames.WebFunnelClick, {
      practice,
      current_step_key: "out-of-scope",
      answer_value: Object.entries(data).flat().toString(),
      full_answer: JSON.stringify(data),
      click_type: "link",
      click_text: t("FUNNEL_OUT_OF_SCOPE_BUTTON"),
    });
  }

  return (
    <>
      <StepContainer>
        <StepContent className="flex flex-col items-center justify-center">
          <Image
            src="/next/images/funnel/out-of-scope.png"
            alt={t("FUNNEL_OUT_OF_SCOPE_IMAGE_ALT")}
            width={240}
            height={240}
          />
          <Heading
            variant="h3"
            alignment="center"
            className="mt-sp-2"
            textWrap="pretty"
          >
            {t("FUNNEL_OUT_OF_SCOPE_TITLE")}
          </Heading>
          <Text className="mt-sp-2 max-w-[460px] text-center">
            {t("FUNNEL_OUT_OF_SCOPE_TEXT")}
          </Text>

          <Button
            type="button"
            size="lg"
            className="my-sp-8"
            asChild
            onClick={getAnswersHandler}
          >
            <Link href={answersUrl}>{t("FUNNEL_OUT_OF_SCOPE_BUTTON")}</Link>
          </Button>
        </StepContent>
      </StepContainer>
      <Footer />
    </>
  );
}
